<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="container">
        <div class="page-header">
            <div class="page-title">
                <h2 *ngIf="role=='cmrc'"><b>Mes ventes</b></h2>
                <h2 *ngIf="role=='adm' || role=='asst'"><b>Ventes</b></h2>
            </div>
        </div>
        <div class="accordion" id="accordionExample" style="background: none;">
            <div class="card" style="background: none;">
                <div class="card-header" id="headingOne" style="background-color: #e9ecef;">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-primary image.png" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Recherche Avancée
                        </button>
                    </h2>
                </div>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <form [formGroup]="advancedSearchForm">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="customers">Client </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input type="text" class="form-control br-30 w-100" id="customers" 
                                                            formControlName="customer" name="customer" placeholder="Saisir le client ..."
                                                            (keyup)="onKeyUp($event,'customer')"  autocomplete="off">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 country-search" *ngIf="role!='cmrc'">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="commercials">Commercial  </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input type="text" class="form-control br-30 w-100" id="commercials" formControlName="commercial" name="commercial" placeholder="Saisir le commercial ..."
                                                            (keyup)="onKeyUp($event,'commercial')"  autocomplete="off">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 country-search">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="country">Famille  </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <select class="form-control-rounded form-control mb-2" id="categories"
                                                        name="sale_category" formControlName="sale_category" >
                                                        <option value="" style="color:gray !important;">Sélectionner une famille</option>
                                                        <option *ngFor="let category of categories" [value]="category.uuid"
                                                            tp="c" [attr.ud]="category.uuid">{{category.category}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search" *ngIf="role=='cmrc'" >
                                            <div class="form-group text-left mb-0" >
                                                <label class="control-label text-black text-left" for="start_date">Du </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input class="form-control br-30 w-100" type="datetime-local" name="start_date" id="start_date" 
                                                            [max]="advancedSearchForm.get('end_date')?.value" formControlName="start_date">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search" *ngIf="role=='cmrc'">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="end_date">Au </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input class="form-control br-30 w-100" type="datetime-local" name="end_date" id="end_date" 
                                                            [min]="advancedSearchForm.get('start_date')?.value" formControlName="end_date"
                                                            [required]="advancedSearchForm.get('start_date')?.value">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row " *ngIf="role!='cmrc'">
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search" >
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="start_date">Du </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input class="form-control br-30 w-100" type="datetime-local" name="start_date" id="start_date" 
                                                            [max]="advancedSearchForm.get('end_date')?.value" formControlName="start_date">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div class="col-lg-3 col-md-4 margin-bottom-20 country-search" *ngIf="role!='cmrc'">
                                            <div class="form-group text-left mb-0">
                                                <label class="control-label text-black text-left" for="end_date">Au </label>
                                            </div>
                                            <div class="row">                                            
                                                <div class="col-md-12 col-sm-12 mx-auto">
                                                    <div class="form-inline my-2 my-lg-0">
                                                        <input class="form-control br-30 w-100" type="datetime-local" name="end_date" id="end_date" 
                                                            [min]="advancedSearchForm.get('start_date')?.value" formControlName="end_date"
                                                            [required]="advancedSearchForm.get('start_date')?.value">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-4 margin-bottom-20 country-search" [ngClass]="{'col-lg-2': role=='adm','col-lg-3': role=='cmrc'}">
                                    <div class="form-group text-left mb-0" *ngIf="!mobile">
                                        <label class="control-label text-black text-left" for="country"></label>
                                    </div>
                                    <div class="row">                                            
                                        <div class="col-md-12 col-sm-12 mx-auto">
                                            <button type="button" class="btn btn-gradient-dark mb-2 mr-2 mt-2  col-sm-12" 
                                                [disabled]="areAllControlsEmpty()" (click)="search()">
                                                <i class="flaticon-search-1 mr-2"></i> Rechercher
                                            </button>
                                            <button type="button" class="btn btn-gradient-default mb-2 mr-2 mt-2  col-sm-12" 
                                                (click)="initList()">Réinitialiser
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div *ngIf="loading_sales" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                margin-bottom: 15%;"></div>
            <div >
            <div class="row" id="cancel-row">
                <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing"  *ngIf="!loading_sales">
                    <div class="statbox widget box box-shadow">
                        <div class="widget-content widget-content-area">
                            <div *ngIf="loading_sales_search" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;margin-bottom: 20%;"></div>
                            <div class="table-responsive mb-4"  *ngIf="!loading_sales_search">
                                <table  id="alter_paginations" class="table table-striped table-bordered" style="width:100%">
                                    <thead >
                                        <tr>
                                            <th>Date de saisie</th>
                                            <th>Client</th>
                                            <th>Désignation</th>
                                            <th>Famille</th>
                                            <th>Prix Unitaire</th>
                                            <th>Quantité</th> 
                                            <th>Total HT</th>  
                                            <th>TVA</th>  
                                            <th>Total TTC</th>  
                                            <th *ngIf="role=='adm' || role=='asst'">Faite par</th>  
                                            <th>Origine</th>   
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let sale of salesDataFiltred">
                                            <ng-container >
                                                <td>{{sale.saleDate | date: 'dd/MM/yyyy- HH:mm' || '---'}}</td>
                                                <td> <a class="text-primary" href="/customer/fromshow;cs={{sale.customerUuid}}">{{sale.customer}}</a></td>
                                                <td>{{sale.designation || '---'}}</td>
                                                <td>{{sale.famille || '---'}}</td>
                                                <td class="text-right">{{sale.prixUnitaire ? (sale.prixUnitaire) : '---'}}</td>
                                                <td class="text-center">{{sale.quantite || '---'}}</td>
                                                <td class="text-right">{{sale.totalHt ? (sale.totalHt) : '---'}}</td>
                                                <td class="text-right">{{sale.tva ? (sale.tva) : '---'}}</td>
                                                <td class="text-right">
                                                <span >
                                                    {{sale.totalTtc ? (sale.totalTtc) : '---'}}
                                                </span>
                                                <span class="month-total" [ngClass]="{'text-success': sale.monthTotal >= 0, 'text-danger': sale.monthTotal < 0}">
                                                    <strong>{{sale.monthTotal}}</strong>
                                                </span>
                                                </td>
                                                <td *ngIf="role=='adm' || role=='asst'">{{sale.faitePar || '---'}}</td>
                                                <td>
                                                    <span *ngIf="sale.origineUuid && sale.origineUuid !== '---'">
                                                        <a href="visite/detail/it;cr={{sale.origineUuid}}" class="text-primary">{{sale.origine}}</a>
                                                    </span>
                                                    <span *ngIf="!sale.origine || sale.origine === '---'">
                                                        ---
                                                    </span>
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    </div>
</div>